import React from 'react';
import { BookOpen, Instagram, Calendar, Lock, Star, ArrowDown } from 'lucide-react';
export function WhatInsideSection() {
  const scrollToPrecios = () => {
    document.getElementById('precios')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-24 bg-brand-dark text-white relative overflow-hidden" data-id="element-290">
      {/* Background accents */}
      <div className="absolute top-0 left-0 w-full h-full opacity-10 pointer-events-none" data-id="element-291">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-brand-primary blur-[150px] rounded-full" data-id="element-292"></div>
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-brand-secondary blur-[150px] rounded-full" data-id="element-293"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-294">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-295">
          <div data-id="element-296">
            <div className="inline-flex items-center space-x-2 mb-6" data-id="element-297">
              <Star className="w-5 h-5 text-brand-gold fill-brand-gold" data-id="element-298" />
              <span className="text-brand-gold font-bold tracking-widest uppercase text-sm" data-id="element-299">
                Contenido Exclusivo
              </span>
            </div>

            <h2 className="text-4xl md:text-5xl font-heading font-medium mb-8 leading-tight" data-id="element-300">
              Te presento: <br data-id="element-301" />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-brand-primary to-brand-secondary font-bold italic" data-id="element-302">
                ESCAPE 9-A-5
              </span>
            </h2>
            <p className="text-rose-100 text-lg mb-10 font-light leading-relaxed" data-id="element-303">
              Este no es un curso teórico aburrido. Es un manual de
              empoderamiento. Una guía paso a paso diseñada para la mujer
              moderna que está lista para tomar el control de su destino
              financiero.
            </p>

            <div className="space-y-8" data-id="element-304">
              <div className="flex group" data-id="element-305">
                <div className="flex-shrink-0" data-id="element-306">
                  <div className="flex items-center justify-center h-14 w-14 rounded-2xl bg-brand-primary/20 border border-brand-primary/30 text-brand-secondary group-hover:bg-brand-primary group-hover:text-white transition-all duration-300" data-id="element-307">
                    <BookOpen className="h-7 w-7" data-id="element-308" />
                  </div>
                </div>
                <div className="ml-6" data-id="element-309">
                  <h3 className="text-xl font-heading font-bold text-white mb-2" data-id="element-310">
                    El Script de Oro
                  </h3>
                  <p className="text-rose-200/80" data-id="element-311">
                    Qué decir exactamente (palabra por palabra) para cerrar
                    ventas con elegancia y confianza, sin sentirte como una
                    vendedora insistente.
                  </p>
                </div>
              </div>

              <div className="flex group" data-id="element-312">
                <div className="flex-shrink-0" data-id="element-313">
                  <div className="flex items-center justify-center h-14 w-14 rounded-2xl bg-brand-primary/20 border border-brand-primary/30 text-brand-secondary group-hover:bg-brand-primary group-hover:text-white transition-all duration-300" data-id="element-314">
                    <Instagram className="h-7 w-7" data-id="element-315" />
                  </div>
                </div>
                <div className="ml-6" data-id="element-316">
                  <h3 className="text-xl font-heading font-bold text-white mb-2" data-id="element-317">
                    La Infiltración en Instagram
                  </h3>
                  <p className="text-rose-200/80" data-id="element-318">
                    Cómo usar tus redes sociales para conectar con dueños de
                    negocios exitosos que necesitan desesperadamente tu ayuda.
                  </p>
                </div>
              </div>

              <div className="flex group" data-id="element-319">
                <div className="flex-shrink-0" data-id="element-320">
                  <div className="flex items-center justify-center h-14 w-14 rounded-2xl bg-brand-primary/20 border border-brand-primary/30 text-brand-secondary group-hover:bg-brand-primary group-hover:text-white transition-all duration-300" data-id="element-321">
                    <Calendar className="h-7 w-7" data-id="element-322" />
                  </div>
                </div>
                <div className="ml-6" data-id="element-323">
                  <h3 className="text-xl font-heading font-bold text-white mb-2" data-id="element-324">
                    El Plan de los 14 Días
                  </h3>
                  <p className="text-rose-200/80" data-id="element-325">
                    Tu mapa exacto para pasar de "empleada" a recibir tu primera
                    comisión en solo dos semanas.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="relative" data-id="element-326">
            <div className="absolute inset-0 bg-gradient-to-tr from-brand-primary to-brand-secondary blur-[60px] opacity-20 rounded-full" data-id="element-327"></div>
            <div className="relative bg-white/5 backdrop-blur-xl border border-white/10 rounded-[2.5rem] p-10 shadow-2xl" data-id="element-328">
              <div className="flex items-center justify-center mb-8" data-id="element-329">
                <div className="w-20 h-20 bg-brand-primary/20 rounded-full flex items-center justify-center border border-brand-primary/30" data-id="element-330">
                  <Lock className="w-10 h-10 text-brand-secondary" data-id="element-331" />
                </div>
              </div>
              <h3 className="text-3xl font-heading font-bold text-center mb-4 italic" data-id="element-332">
                Tu teléfono es tu llave.
              </h3>
              <p className="text-center text-rose-100 mb-10" data-id="element-333">
                Este PDF es la combinación secreta. Deja de vender tu tiempo por
                migajas. Empieza a cobrar por tu valor como una mujer de
                negocios.
              </p>

              <div className="bg-brand-dark/50 rounded-2xl p-6 border border-white/5" data-id="element-334">
                <div className="flex justify-between items-center mb-3" data-id="element-335">
                  <span className="text-rose-200 text-sm font-medium" data-id="element-336">
                    Potencial de Ingresos
                  </span>
                  <span className="text-brand-secondary font-bold tracking-wider" data-id="element-337">
                    ILIMITADO
                  </span>
                </div>
                <div className="w-full bg-white/10 rounded-full h-3 mb-2" data-id="element-338">
                  <div className="bg-gradient-to-r from-brand-primary to-brand-secondary h-3 rounded-full shadow-[0_0_15px_rgba(236,72,153,0.5)]" style={{
                  width: '92%'
                }} data-id="element-339"></div>
                </div>
                <p className="text-right text-xs text-rose-300/70" data-id="element-340">
                  Basado en resultados de alumnas
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* CTA scroll to price */}
        <div className="mt-16 text-center" data-id="element-341">
          <p className="text-rose-300/60 text-sm uppercase tracking-widest font-semibold mb-4" data-id="element-342">
            Todo esto por menos de un café
          </p>
          <button onClick={scrollToPrecios} className="inline-flex flex-col items-center gap-2 group" data-id="element-343">
            <span className="inline-flex items-center gap-2 bg-brand-secondary text-white font-bold uppercase tracking-wider text-sm px-8 py-4 rounded-full shadow-lg shadow-rose-500/30 hover:bg-rose-500 transition-all duration-200" data-id="element-344">
              QUIERO ESTE MÉTODO — VER PRECIO
            </span>
            <ArrowDown className="w-5 h-5 text-rose-400 animate-bounce group-hover:text-white transition-colors" data-id="element-345" />
          </button>
        </div>
      </div>
    </section>;
}